<section class="flex items-center cursor-pointer" (click)="goBack()">
  <i class="pi pi-arrow-left text-primary" style="font-size: 2rem"></i>
  <h2 class="text-primary poppins-medium px-2">{{title}}</h2>
</section>